import {useState} from "react";

export default function FooterComponent(){

    const [year] = useState(new Date().getFullYear());

    return (
    <footer id="footer">
      <ul className="icons">

        <li><a href="https://github.com/danilor" target={'_blank'} className="icon brands fa-github"><span className="label">Github</span></a></li>
        <li><a href="https://www.instagram.com/daniloramirezcr_thearkhive" target={'_blank'} className="icon brands fa-instagram"><span className="label">Instagram</span></a></li>
      </ul>
      <p className="copyright">&copy;{year} Zen UI. Documentation made with love with: <a href="https://www.npmjs.com/package/docunatorjs">Docunator</a></p>
    </footer>
  );
}
